import { render } from "./FavoriteDetails.vue?vue&type=template&id=3820442f"
import script from "./FavoriteDetails.vue?vue&type=script&lang=js"
export * from "./FavoriteDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__